export default {
  areaID: {
    value: '',
    options: [],
    required: false,
    state: null
  },
  name: {
    value: '',
    maxlength: '70',
    required: true,
    state: null
  },
  businessTypeID: {
    value: null,
    options: [],
    required: true,
    state: null
  },
  insuranceID: {
    value: null,
    options: [],
    required: true,
    state: null
  },
  note: {
    value: null,
    maxlength: '120',
    required: false,
    state: null
  },
  fieldRule: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  valueRule: {
    value: '',
    maxlength: '70',
    required: false,
    state: null
  },
  typeRule: {
    value: '',
    options: [],
    required: false,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configuration/product/product-form.js